import { motion } from "framer-motion";
import {
  Sparkle, Blueprint, Handshake, Megaphone, GraduationCap,
  SealCheck, ShoppingBag, Storefront, Headset,
} from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

const ICONS = { Sparkle, Blueprint, Handshake, Megaphone, GraduationCap, SealCheck, ShoppingBag, Storefront, Headset };

export const WhyFranchise = () => {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why" className="relative bg-[#1A1A1A] text-[#FAFAF7] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal>
            <p className="text-sm tracking-luxe uppercase text-[#8B7355] mb-6">{t.why.kicker}</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              {t.why.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-white/60 max-w-xl leading-relaxed">{t.why.subtitle}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {t.why.items.map((it, i) => {
            const Icon = ICONS[it.icon] || Sparkle;
            return (
              <Reveal
                key={i}
                delay={(i % 3) * 0.08}
                className="group bg-[#1A1A1A] p-9 md:p-11 hover:bg-[#232323] transition-colors duration-500"
              >
                <motion.div
                  whileHover={{ rotate: -6, scale: 1.08 }}
                  transition={{ type: "spring", stiffness: 300, damping: 15 }}
                  className="inline-flex"
                >
                  <Icon size={40} weight="thin" className="text-[#C9BEAF] group-hover:text-[#8B7355] transition-colors" />
                </motion.div>
                <h3 className="mt-6 text-lg font-medium">{it.title}</h3>
                <p className="mt-2 text-sm text-white/50 leading-relaxed">{it.text}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
